const insertGTMScript = (gtmContainerId: string) => {
  const { head } = document;

  const html = `
  window.dataLayer = window.dataLayer || [];
  window.gtag = function() {dataLayer.push(arguments);};
(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${gtmContainerId}');
  `;

  const script = document.createElement('script');
  script.id = 'gtm-script';
  script.innerHTML = html;
  head.insertBefore(script, head.firstChild);
};

export const removeGTM = () => {
  window.dataLayer = [];
  document.querySelectorAll('#gtm-script')?.forEach((el) => el.remove());
  document
    .querySelectorAll('script[src^="https://www.googletagmanager.com"]')
    .forEach((el) => el.remove());
};

export const initializeGTM = (gtmContainerId: string) => {
  insertGTMScript(gtmContainerId);
};
